import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import firebase from 'firebase/app';
import 'firebase/firestore';
import Button from '@material-ui/core/Button';
import { makeStyles, Typography } from '@material-ui/core';
import fileDownload from 'js-file-download';
import Axios from 'axios';

import logo from './logo.png'
import { Upload } from './types';

const useStyles = makeStyles({
  text: {
    margin: '20px 0'
  },
});

function useFileDetails(id: string) {
  const [files, setFiles] = useState<Upload>();

  useEffect(() => {
    const db = firebase.firestore();
    const unsub = db
      .collection('uploads')
      .doc(id)
      .onSnapshot(snapshot => {
        setFiles(snapshot.data() as Upload)
      });
    return () => {
      unsub();
    };
  }, [id]);

  return files;
}

interface ParamTypes {
  id: string;
}

export default function Download() {
  const classes = useStyles();
  const { id } = useParams<ParamTypes>();
  const fileDetails = useFileDetails(id);

  const download = async () => {
    const db = firebase.firestore();
    db.collection('uploads')
      .doc(id)
      .update("downloadCount", firebase.firestore.FieldValue.increment(1))
    Axios.get(fileDetails!.downloadURL, {
      responseType: 'blob',
    }).then(res => {
      fileDownload(res.data, fileDetails!.filename);
    });
  }

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
      </header>
      <main>
        <Typography className={classes.text}>Please download from a computer<br />Thank you!</Typography>
        <Button color="primary" variant="contained" onClick={download}>
          Download
        </Button>
      </main>
    </div>
  );
}